import type { TAnyObject } from '@/types/object'
import { isUndefined } from '@/utils/is'

const serialize = (value: any): string => JSON.stringify(value)
const deserialize = <T = any>(value: string): T => JSON.parse(value)

export class BrowserStorage {
  static setItem<T = any>(key: string, value: T) {
    if (value === null || isUndefined(value)) {
      localStorage.removeItem(key)
      return
    }
    localStorage.setItem(key, serialize(value))
  }

  static patchItem<T extends TAnyObject = TAnyObject>(key: string, value: Partial<T>) {
    const item = BrowserStorage.getItem<T>(key) || {}
    const nextItem = { ...item, ...value }
    BrowserStorage.setItem(key, nextItem)
  }

  static getItem<T = any>(key: string): T | null {
    const value = localStorage.getItem(key)
    if (value === null) return value
    return deserialize<T>(value)
  }

  static removeItem(key: string) {
    localStorage.removeItem(key)
  }
}
